import { LicenseMasterStatusEnum } from "@src/apis/ModularClient";

export const HasActiveLicense = (status: LicenseMasterStatusEnum): boolean => {
  if (
    status === LicenseMasterStatusEnum.PaidUp ||
    status === LicenseMasterStatusEnum.PreCancel ||
    status === LicenseMasterStatusEnum.PaymentProcessing ||
    status === LicenseMasterStatusEnum.Trial
  ) {
    return true;
  }
  return false;
};
